import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { Org } from "../domains/Org";
import { OrgAddUserFromEmailStore } from "./OrgAddUserFromEmailStore";
import { OrgAddUserStore } from "./OrgAddUserStore";
import { OrgFundsStore } from "./OrgFundsStore";
import { OrgsStore } from "./OrgsStore";

export class OrgStore {
  id: string = "";
  keyword: string = "";
  orgsStore: OrgsStore;
  fundsStore: OrgFundsStore;

  showAddUserDlg = false;

  addUserStore: OrgAddUserStore;
  addUserFromEmailStore: OrgAddUserFromEmailStore;
  org?: Org;

  loadingTeachers: boolean = false;
  loadingMembers: boolean = false;

  constructor(orgsStore: OrgsStore) {
    makeAutoObservable(this, {
      orgsStore: false,
      members: computed,
      notTeacherMembers: computed,
    });
    this.orgsStore = orgsStore;
    this.fundsStore = new OrgFundsStore(this);
    this.addUserStore = new OrgAddUserStore(this);
    this.addUserFromEmailStore = new OrgAddUserFromEmailStore(this);
  }

  get members() {
    return (
      this.org?.members.filter((m) => {
        return (
          m.firstName.toLowerCase().includes(this.keyword.toLowerCase()) ||
          m.lastName.toLowerCase().includes(this.keyword.toLowerCase())
        );
      }) || []
    );
  }

  get notTeacherMembers() {
    console.log(this.org?.members, this.org?.teachers);
    return (
      this.org?.members.filter((m) => {
        return !this.org?.teachers.find((x: any) => x.teacherId === m.id);
      }) || []
    );
  }

  @action
  active(id: string) {
    if (this.id === id) return;
    this.id = id;
    this.keyword = "";
    console.log("active org id", id);
    Api.org.org(id).then((res) => {
      runInAction(() => {
        this.org = new Org(res.data.org);
      });
      this.loadMembers();
      this.loadTeachers();
    });
  }

  @action edit() {
    this.orgsStore.orgEdit.edit(this.id);
  }

  @action loadMembers() {
    this.loadingMembers = true;
    this.org?.loadMembers().finally(() => {
      runInAction(() => {
        this.loadingMembers = false;
      });
    });
  }

  @action loadTeachers() {
    this.loadingTeachers = true;
    this.org?.loadTeachers().finally(() => {
      runInAction(() => {
        this.loadingTeachers = false;
      });
    });
  }
}
